import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
// import { ScrollSmoother } from 'gsap/ScrollSmoother';


// a basic accordion.
$(function() {
  $('.accordion .title').on( 'click', function(e) {
    e.preventDefault();

    var $this = $(this);
    var $accordion = $this.parent();
    var $content = $this.next();

    $accordion.parent().find('.content').css('max-height', '0');

    if ($accordion.hasClass('open')) {
      $accordion.removeClass('open');
      $accordion.addClass('closed');
    } else {
      $accordion.siblings().removeClass('open');
      $accordion.siblings().removeClass('closed');
      $accordion.removeClass('closed');
      $accordion.addClass('open');
      $content.css('max-height', $content[0].scrollHeight);
    }
  });
})

$(function() {
  if( $( '.js-sort' ).length ){
    // Filter by News Catagory
    $( document ).on( 'click', '.js-sort a', function( e ) {
      e.preventDefault();
    
      //grabs the catagory given ( in this case this is the catagory slug )
      var $this = $( this );
      $this.parent().children().removeClass( 'active' );
      $this.addClass( 'active' );
    
      let catagory = $this.data( 'catagory' );
    
      //foreach card we check if the catagory slug exists in the class attributes. If it does, show it otherwise hides
      $( '.filter-item' ).each( function() {
    
        if ( $( this ).hasClass( catagory ) || catagory == 'all' ) {
          $( this ).show();
        } else {
          $( this ).hide();
        }
      });
    
    });
  }
})

if( $( '[data-scale]' ).length || $( '[data-fadeup]' ).length || $( '[data-anim]' ).length || $( '.timeline' ).length ) {
  gsap.registerPlugin( ScrollTrigger );
}

$(function() {
  //basic fade up animation
  if ( $( '[data-fadeup]' ).length ) {
    let fadeIn = document.querySelectorAll( '[data-fadeup]' );

    fadeIn.forEach( ( elem, i ) => {
      gsap.set( fadeIn, {
        opacity: 0,
        transform: 'translateY( 20% )'
      } );

      ScrollTrigger.create( {
        trigger: elem,
        start: 'center bottom',
        // markers: true,

        onEnter: () => gsap.to( elem, {
          opacity: 1,
          transform: 'translateY( 0 )',
          overwrite: 'auto',
        }),
      });
    });
  }

  //parallax for side by side content
  if ( $( '[data-anim1]' ).length ) {
    let first = document.querySelectorAll( '[data-anim1]' );
    let second = document.querySelectorAll( '[data-anim2]' );
    
    first.forEach( ( first, i ) => {
      let trigger = $(first).parent().parent();
      gsap.fromTo (
        first,
        { y: -100 },
        {
          y: 40,
          scrollTrigger: {
            trigger: trigger,
            scrub: 1,
            start: 'top bottom+=10%',
            end: 'bottom-=50 bottom-=30%',
          }
        }
      );
    })

    second.forEach( ( second, i ) => {
      let trigger = $( second ).parent().parent();
      gsap.fromTo (
        second,
        { y: 50 },
        {
          y: -25,
          scrollTrigger: {
            trigger: trigger,
            scrub: 1,
            start: 'top bottom+=10%',
            end: 'bottom-=50 bottom-=30%',
          }
        }
      );
    })

    if ($( '[data-anim3]' ).length ) {
      let third = document.querySelectorAll( '[data-anim3]' );
      
      third.forEach( ( third, i ) => {
        let trigger = $(third).parent().parent();
        gsap.fromTo (
          third,
          { y: 130 },
          {
            y: -30,
            scrollTrigger: {
              trigger: trigger,
              scrub: 1,
              start: 'top bottom+=10%',
              end: 'bottom-=50 bottom-=30%',
            }
          }
        );
      })
    }
  }
})

//timeline || about page timeline

if( $( '.timeline' ).length ) {

  gsap.registerPlugin( DrawSVGPlugin );
  let mm = gsap.matchMedia();
  
  let tlCard = document.querySelectorAll( '.tl-card' );

  //the only difference is the activate class being higher not centered due to nav
  mm.add(
    //desktop
    "( min-width: 425px )", () => {
        
      gsap.fromTo('#path', {
        drawSVG: 0
      }, {
        drawSVG: '100%',
        ease: 'linear',
        scrollTrigger: {
          trigger: '.tl-svg',
          scrub: 0.5,
          start: 'top center',
          end: 'bottom center',
        }
      })

      tlCard.forEach( ( tlCard, i ) => {
        let line = $( tlCard ).find( '#line' )
    
        //Card anim
        ScrollTrigger.create ( {
          trigger: tlCard,
          start: 'center-=3% center', //aditional space to respond to margin offsets
          end: 'bottom bottom',
    
          onEnter: () => tlCard.classList.add( 'active' ),
          onEnterBack: () => tlCard.classList.remove( 'active' )
        })
        
        // svg bullet draw || could use dash offset and animate easily,
        // but if you have the library why not use it
        ScrollTrigger.create ( {
          trigger: tlCard,
          start: 'center-=3% center', //aditional space to respond to margin
          end: 'bottom bottom',
    
          //more handled with active class in sass file under .timeline
          onEnter: () => gsap.fromTo ( line, { 
            drawSVG: 0,
          } , {
            drawSVG: '100%',
            ease: 'ease-in',
          }),
    
          onEnterBack: () => gsap.fromTo ( line, { 
            drawSVG: '100%',
          }, {
            drawSVG: 0,
            ease: 'ease-out',
          })
        })
      })
    }
  );
  
  mm.add (
    //mobile
    "( max-width: 425px )", () => {

      gsap.fromTo('#path', {
        drawSVG: 0
      }, {
        drawSVG: '100%',
        ease: 'linear',
        scrollTrigger: {
          trigger: '.tl-svg',
          scrub: 0.5,
          start: 'top center+=5%',
          end: 'bottom center',
        }
      })
  
      tlCard.forEach( ( tlCard, i ) => {
        let line = $( tlCard ).find( '#line' )
    
        //Card anim
        ScrollTrigger.create ( {
          trigger: tlCard,
          start: 'center-=5% center', //aditional space to respond to margin
          end: 'bottom bottom',
    
          onEnter: () => tlCard.classList.add( 'active' ),
          onEnterBack: () => tlCard.classList.remove( 'active' )
        })
        
        // svg bullet draw || could use dash offset and animate easily,
        // but if you have the library why not use it
        ScrollTrigger.create ( {
          trigger: tlCard,
          start: 'center-=5% center', //aditional space to respond to margin
          end: 'bottom bottom',
    
          //more handled with active class in sass file under .timeline
          onEnter: () => gsap.fromTo ( line, { 
            drawSVG: 0,
          } , {
            drawSVG: '100%',
            ease: 'ease-in',
          }),
    
          onEnterBack: () => gsap.fromTo ( line, { 
            drawSVG: '100%',
          }, {
            drawSVG: 0,
            ease: 'ease-out',
          })
        })
      })
    }
  );
}

//OPTIMIZE LATER | Im feeling lazy

//menu page sorting
if( $( '.menu' ).length ){
  let url = window.location.href;

  // Filter by News Catagory
  $( document ).on( 'click', '.menu-sort a.ver-1', function( e ) {
    e.preventDefault();
  
    //grabs the catagory given ( in this case this is the catagory slug )
    var $this = $( this );
    $('.tag-btn').removeClass( 'active' );
    $this.addClass( 'active' );
  
    let catagory = $this.data( 'catagory' );
  
    //foreach card we check if the catagory slug exists in the class attributes. If it does, show it otherwise hides
    $( '.filter-item' ).each( function() {
  
      if ( $( this ).hasClass( catagory ) || catagory == 'all' ) {
        $( this ).show();
        location.hash = catagory;
      } else {
        $( this ).hide();
      }
    });
  
  });

  $( document ).on( 'click', '.menu-sort a.gluten-menu-toggle', function( e ) {
    e.preventDefault();
  
    //grabs the catagory given ( in this case this is the catagory slug )
    var $this = $( this );
    $('.tag-btn').removeClass( 'active' );
    $this.addClass( 'active' );

    if( $( '.grid-wrapper' ).hasClass( 'gluten-free-menu' ) ){
      $( '.slug-menu' ).hide()
      $( '.veg-menu' ).hide()
      $( '.gluten-free-menu' ).show()
      location.hash = 'gluten-menu';
    } else {
      $( '.veg-menu' ).hide()
      $( '.gluten-free-menu' ).hide()
      $( '.slug-menu' ).show()
    }
  });

  $( document ).on( 'click', '.menu-sort a.veg-menu-toggle', function( e ) {
    e.preventDefault();
  
    //grabs the catagory given ( in this case this is the catagory slug )
    var $this = $( this );
    $('.tag-btn').removeClass( 'active' );
    $this.addClass( 'active' );

    if( $( '.grid-wrapper' ).hasClass( 'veg-menu' ) ){
      $( '.slug-menu' ).hide()
      $( '.gluten-free-menu' ).hide()
      $( '.veg-menu' ).show()
      location.hash = 'veg-menu';
    } else {
      $( '.veg-menu' ).hide()
      $( '.gluten-free-menu' ).hide()
      $( '.slug-menu' ).show()
    }
  });
}

//check to see if a menu block has items within. If not then Hide it. 
if( $('.menu').length ){
  let menuBlock = document.querySelectorAll( '.menu-grid' );

  menuBlock.forEach( ( menuBlock , i ) => {
  
    let item = $( menuBlock ).find('.menu-item')

    if( item.length < 1 ){
      $( menuBlock ).hide()
    } else{
      $( menuBlock ).show()
    }
  })
}

if( $( '.sticky-me' ).length ){
  //sticky menu
  ScrollTrigger.create ( {
    trigger: $('.page-header'),
    start: 'bottom-=50 top',
    end: 'bottom bottom',

    onEnter: () => {
      $('.sticky-me').addClass( 'sticky' );
      $( '.menu' ).addClass('menu-padding');
    },
    onEnterBack: () => {
      $('.sticky-me').removeClass( 'sticky' );
      $( '.menu' ).removeClass('menu-padding');
    }
  })
}

$(function() {
  if( $( '.scale' ).length ){
    $('.scale').addClass('run')
  }
})